/* =========================================================================
   ORÉE — interactions.  Vanilla JS, no dependencies.  Defer-loaded.
   Covers: scroll reveals · drawer gallery menu · showcase hover-swap
           · announcement rotation.  Re-binds on Shopify section events.
   ========================================================================= */
(function () {
  "use strict";

  /* ---- Reveal on scroll ------------------------------------------------ */
  function bindReveals(root) {
    var els = (root || document).querySelectorAll(".oree-reveal:not(.is-in), .oree-img-reveal:not(.is-in)");
    if (!("IntersectionObserver" in window)) { els.forEach(function (e) { e.classList.add("is-in"); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add("is-in"); io.unobserve(en.target); }
      });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---- Drawer gallery menu --------------------------------------------- */
  function openDrawer(d) { d.setAttribute("data-open", "true"); document.documentElement.style.overflow = "hidden"; }
  function closeDrawer(d) { d.removeAttribute("data-open"); document.documentElement.style.overflow = ""; }

  function bindDrawer(root) {
    (root || document).querySelectorAll("[data-oree-drawer]").forEach(function (drawer) {
      if (drawer.__bound) return; drawer.__bound = true;
      var id = drawer.getAttribute("data-oree-drawer");
      document.querySelectorAll('[data-oree-drawer-open="' + id + '"]').forEach(function (btn) {
        btn.addEventListener("click", function (e) { e.preventDefault(); openDrawer(drawer); });
      });
      drawer.querySelectorAll("[data-oree-drawer-close]").forEach(function (btn) {
        btn.addEventListener("click", function () { closeDrawer(drawer); });
      });
      // category hover → swap preview image
      var imgs = drawer.querySelectorAll("[data-oree-room-image]");
      drawer.querySelectorAll("[data-oree-room]").forEach(function (row) {
        var key = row.getAttribute("data-oree-room");
        var activate = function () {
          drawer.querySelectorAll("[data-oree-room]").forEach(function (r) { r.removeAttribute("data-active"); });
          row.setAttribute("data-active", "true");
          imgs.forEach(function (im) { im.style.opacity = (im.getAttribute("data-oree-room-image") === key) ? "1" : "0"; });
        };
        row.addEventListener("mouseenter", activate);
        row.addEventListener("focus", activate);
      });
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") document.querySelectorAll('[data-oree-drawer][data-open]').forEach(closeDrawer);
    });
  }

  /* ---- Showcase hover-swap (featured image + name + copy) -------------- */
  function bindShowcase(root) {
    (root || document).querySelectorAll("[data-oree-showcase]").forEach(function (sc) {
      if (sc.__bound) return; sc.__bound = true;
      var media = sc.querySelectorAll("[data-oree-feat-image]");
      var nameEl = sc.querySelector("[data-oree-feat-name]");
      var descEl = sc.querySelector("[data-oree-feat-desc]");
      var nameLinkEl = sc.querySelector("[data-oree-feat-link-name]");
      var rows = sc.querySelectorAll("[data-oree-piece]");

      function activate(row) {
        var key = row.getAttribute("data-oree-piece");
        rows.forEach(function (r) { r.removeAttribute("data-active"); });
        row.setAttribute("data-active", "true");
        media.forEach(function (m) { m.style.opacity = (m.getAttribute("data-oree-feat-image") === key) ? "1" : "0"; });
        if (nameEl && row.dataset.name) nameEl.textContent = row.dataset.name;
        if (descEl && row.dataset.desc) descEl.textContent = row.dataset.desc;
        if (nameLinkEl && row.dataset.url) nameLinkEl.setAttribute("href", row.dataset.url);
      }

      // Desktop: hover swaps the featured image/name/desc
      rows.forEach(function (row) {
        row.addEventListener("mouseenter", function () { activate(row); });
      });

      // Mobile / touch: swap as each row scrolls through the center of the viewport
      var isCoarsePointer = window.matchMedia && window.matchMedia("(hover: none), (pointer: coarse)").matches;
      if (isCoarsePointer && "IntersectionObserver" in window && rows.length) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) activate(en.target);
          });
        }, { root: null, rootMargin: "-45% 0px -45% 0px", threshold: 0 });
        rows.forEach(function (row) { io.observe(row); });
      }
    });
  }
  /* ---- Announcement rotation ------------------------------------------ */
  function bindAnnounce(root) {
    (root || document).querySelectorAll("[data-oree-announce]").forEach(function (bar) {
      if (bar.__bound) return; bar.__bound = true;
      var notes = bar.querySelectorAll("[data-note]");
      if (notes.length > 1) {
        var i = 0;
        setInterval(function () {
          notes[i].style.opacity = "0";
          i = (i + 1) % notes.length;
          notes[i].style.opacity = "1";
        }, 5200);
      }
      var dismiss = bar.querySelector("[data-oree-announce-dismiss]");
      if (dismiss) dismiss.addEventListener("click", function () { bar.style.display = "none"; });
    });
  }

  /* ---- Sticky header state on scroll ----------------------------------- */
  function bindHeader() {
    var header = document.querySelector("[data-oree-header]");
    if (!header || header.__bound) return; header.__bound = true;
    var onScroll = function () { header.toggleAttribute("data-scrolled", window.scrollY > 40); };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  function init(root) { bindReveals(root); bindDrawer(root); bindShowcase(root); bindAnnounce(root); bindHeader(); }

  document.addEventListener("DOMContentLoaded", function () { init(document); });

  /* Shopify theme-editor: re-bind when sections are re-rendered. */
  document.addEventListener("shopify:section:load", function (e) { init(e.target); });
  document.addEventListener("shopify:section:select", function (e) { init(e.target); });
})();
